import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { getBouyguesAddressAPIValidationErrors } from './getBouyguesAddressAPIValidationErrors'

// TODO fuse with getBouyguesAddressAPIValidationErrors which should just have the mapping exceptions
export const getAPIErrors = (error: Record<string, unknown>) => {
  const i18n = useI18n()

  const errors = {}

  Object.assign(errors, getBouyguesAddressAPIValidationErrors(error, i18n))

  return errors
}
